const getAccountInformation = () => {
    return ApiClient.get('/account');
};

const updateAccountInformation = (data, fieldsToValidate) => {
    const params = fieldsToValidate ? { field: fieldsToValidate } : {};
    return ApiClient.put('/account', params, data);
};

export { getAccountInformation, updateAccountInformation };
